import React from "react";
import Popover from "@material-ui/core/Popover";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import { Tooltip } from "@material-ui/core";
import ViewColumnIcon from "mdi-react/ViewColumnIcon";
import { buildingSearchColumns, defaultVisibleColumns } from "./columnConfig";

export default function ColumnConfigurator({ visibleColumns, setVisibleColumns }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleToggle = (columnId) => {
    const col = buildingSearchColumns.find(c => c.id === columnId);
    if (col && col.alwaysVisible) return;

    const newVisible = visibleColumns.includes(columnId)
      ? visibleColumns.filter(id => id !== columnId)
      : [...visibleColumns, columnId];
    setVisibleColumns(newVisible);
  };

  const handleReset = () => {
    setVisibleColumns([...defaultVisibleColumns]);
  };

  return (
    <span>
      <Tooltip title="Configure Table Columns">
        <IconButton onClick={e => setAnchorEl(e.currentTarget)} size="small">
          <ViewColumnIcon size={18} />
        </IconButton>
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <div style={{ padding: 16, maxHeight: 400, overflow: "auto", minWidth: 250 }}>
          <div style={{ fontWeight: "bold", marginBottom: 8, fontSize: 14 }}>Show Columns</div>
          {buildingSearchColumns.map(col => (
            <div key={col.id}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={col.alwaysVisible || visibleColumns.includes(col.id)}
                    disabled={col.alwaysVisible}
                    onChange={() => handleToggle(col.id)}
                    size="small"
                    color="primary"
                  />
                }
                label={<span style={{ fontSize: 13 }}>{col.label}</span>}
              />
            </div>
          ))}
          <Button size="small" onClick={handleReset} style={{ marginTop: 8 }} color="primary">
            Reset to Default
          </Button>
        </div>
      </Popover>
    </span>
  );
}
